<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="模糊查询:">
        <el-input size="small" v-model="formInline.userName" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.fatherid" placeholder="输入渠道号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>

    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border style="width: 100%;">
      <el-table-column align="center" prop="id" label="ID" width="80"></el-table-column>
      <el-table-column align="center" prop="phone" label="手机号"></el-table-column>
      <el-table-column align="center" prop="starttime" label="注册时间"></el-table-column>
      <el-table-column align="center" prop="deadline" label="到期时间"></el-table-column>
      <el-table-column align="center" prop="fatherid" label="渠道"></el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span>{{ scope.row.closed == 1 ? '已注销' : (scope.row.viptype > 0 ? '已支付' : '未支付') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="showDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 用户详情编辑弹窗 -->
    <el-dialog
      title="用户详情编辑"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="detailVisible"
      width="80%"
      top="3vh">
      <el-form :model="detailForm" label-width="120px" size="small">
        <el-divider content-position="left">基本信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="8"><el-form-item label="ID"><el-input v-model="detailForm.id" disabled /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="用户名"><el-input v-model="detailForm.username" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="昵称"><el-input v-model="detailForm.username1" /></el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8"><el-form-item label="手机号"><el-input v-model="detailForm.phone" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="备用手机"><el-input v-model="detailForm.phone_bac" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="密码"><el-input v-model="detailForm.password" /></el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12"><el-form-item label="OpenID"><el-input v-model="detailForm.openid" /></el-form-item></el-col>
        </el-row>

        <el-divider content-position="left">渠道信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="8"><el-form-item label="渠道"><el-input v-model="detailForm.channel" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="用户ID"><el-input v-model="detailForm.userid" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="上级ID"><el-input v-model="detailForm.fatherid" /></el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8"><el-form-item label="邀请码"><el-input v-model="detailForm.inviteid" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="旧邀请码"><el-input v-model="detailForm.oldinviteid" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="版本号"><el-input v-model="detailForm.versioncode" /></el-form-item></el-col>
        </el-row>

        <el-divider content-position="left">会员信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="8"><el-form-item label="VIP类型"><el-input v-model="detailForm.viptype" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="到期时间"><el-input v-model="detailForm.deadline" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="VIP手机"><el-input v-model="detailForm.vipphone" /></el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8"><el-form-item label="注册时间"><el-input v-model="detailForm.starttime" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="最后登录"><el-input v-model="detailForm.dl" /></el-form-item></el-col>
        </el-row>

        <el-divider content-position="left">设备信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="8"><el-form-item label="IMEI"><el-input type="textarea" :autosize="{ minRows: 3, maxRows: 8 }" v-model="detailForm.imeis" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="IMSI"><el-input v-model="detailForm.imsis" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="谷歌版本"><el-input v-model="detailForm.googleversioncode" /></el-form-item></el-col>
        </el-row>

        <el-divider content-position="left">积分/标签</el-divider>
        <el-row :gutter="20">
          <el-col :span="6"><el-form-item label="积分"><el-input v-model="detailForm.points" /></el-form-item></el-col>
          <el-col :span="6"><el-form-item label="标签"><el-input v-model="detailForm.tag" /></el-form-item></el-col>
          <el-col :span="6"><el-form-item label="国内"><el-input v-model="detailForm.inchina" /></el-form-item></el-col>
          <el-col :span="6"><el-form-item label="邀请数"><el-input v-model="detailForm.invitenum" /></el-form-item></el-col>
        </el-row>

        <el-divider content-position="left">三方信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="8"><el-form-item label="三方UID"><el-input v-model="detailForm.third_uid" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="三方OpenID"><el-input v-model="detailForm.third_openid" /></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="三方名称"><el-input v-model="detailForm.third_name" /></el-form-item></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8"><el-form-item label="三方昵称"><el-input v-model="detailForm.username_third" /></el-form-item></el-col>
        </el-row>

        <el-divider content-position="left">状态</el-divider>
        <el-row :gutter="20">
          <el-col :span="6"><el-form-item label="注销"><el-input v-model="detailForm.closed" /></el-form-item></el-col>
          <el-col :span="6"><el-form-item label="注销时间"><el-input v-model="detailForm.stonetime" /></el-form-item></el-col>
          <el-col :span="6"><el-form-item label="关注"><el-input v-model="detailForm.follow" /></el-form-item></el-col>
          <el-col :span="6"><el-form-item label="虚拟ID"><el-input v-model="detailForm.virtual_id" /></el-form-item></el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer" style="display:flex;justify-content:space-between">
        <el-button size="small" type="danger" @click="cleanToken">清除登录状态</el-button>
        <div>
          <el-button size="small" @click="detailVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click="submitDetail">提交修改</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { vipList, getUserDetail, updateUser, cleanUserToken } from '../../api/userMG'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      loading: false,
      detailVisible: false,
      detailForm: {},
      detailOriginal: {},
      formInline: {
        pageNo: 0,
        pageSize: 10,
        userName: null,
        fatherid: null,
        token: localStorage.getItem('logintoken')
      },
      listData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  components: { Pagination },

  created() {
    this.getdata(this.formInline)
  },

  methods: {
    getdata(parameter) {
      this.loading = true
      vipList({ ...parameter })
        .then(res => {
          this.loading = false
          if (res.success !== false) {
            this.listData = res.data.records || []
            this.pageparm.pageSize = res.data.size || res.data.pageSize
            this.pageparm.total = res.data.total
          } else {
            this.$message({ type: 'info', message: res.message })
          }
        })
        .catch(() => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },

    callFather(parm) {
      this.formInline.pageNo = parm.currentPage - 1
      this.getdata(this.formInline)
    },

    search() {
      this.formInline.pageNo = 0
      this.getdata(this.formInline)
    },

    showDetail(row) {
      var pad = function (n) { return String(n).padStart(2, '0') }
      var fmt = function (ts) {
        if (!ts && ts !== 0) return ''
        var d = new Date(ts)
        if (isNaN(d.getTime())) return String(ts)
        return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
          ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds())
      }
      getUserDetail({ userId: row.userid || row.id })
        .then(res => {
          var data = { ...res.data }
          var timeFields = ['starttime', 'deadline', 'dl', 'stonetime']
          timeFields.forEach(function (f) {
            if (data[f] !== undefined && data[f] !== null) data[f] = fmt(data[f])
          })
          this.detailForm = data
          this.detailOriginal = { ...data }
          this.detailVisible = true
        })
        .catch(() => {
          this.$message.error('加载详情失败')
        })
    },

    submitDetail() {
      var changed = {}
      var fields = ['username', 'openid', 'username1', 'phone', 'phone_bac', 'password',
        'channel', 'imeis', 'userid', 'versioncode', 'inviteid', 'fatherid',
        'vipphone', 'googleversioncode', 'points', 'inchina', 'imsis', 'tag',
        'starttime', 'invitenum', 'deadline', 'viptype',
        'third_uid', 'third_openid', 'third_name', 'username_third',
        'follow', 'virtual_id', 'stonetime', 'dl', 'oldinviteid', 'closed']

      for (var i = 0; i < fields.length; i++) {
        var f = fields[i]
        var nv = this.detailForm[f] !== undefined ? String(this.detailForm[f]) : ''
        var ov = this.detailOriginal[f] !== undefined ? String(this.detailOriginal[f]) : ''
        if (nv !== ov) changed[f] = nv
      }

      if (Object.keys(changed).length === 0) {
        this.$message.info('没有修改')
        return
      }

      changed.userId = this.detailOriginal.id
      changed.token = localStorage.getItem('logintoken')

      updateUser(changed)
        .then(res => {
          if (res.success !== false) {
            this.$message.success('保存成功')
            this.detailVisible = false
            this.getdata(this.formInline)
          } else {
            this.$message.error(res.message || '保存失败')
          }
        })
        .catch(() => {
          this.$message.error('保存失败')
        })
    },

    cleanToken() {
      var username = this.detailForm.username1 || ''
      if (!username) {
        this.$message.warning('无法获取用户名')
        return
      }
      this.$confirm('确定要清除用户「' + username + '」的登录状态吗？', '清除登录状态', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cleanUserToken({ username: username })
          .then(() => {
            this.$message.success('清理成功')
          })
          .catch(() => {
            this.$message.error('操作失败')
          })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/goods/Goods.vue